module.exports = __webpack_public_path__ + "img/pic5.68fc3350.png";